export const myonex = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 15,
  inputPaddingInline: 9,

  inputHeight: 29,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Montserrat", sans-serif',
  inputColor: "#4A4F54",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 300,

  inputBorderColor: "#FFFFFF",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#4A4F54",
  inputHoverBorderColor: "#FFFFFF",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 15,
  selectPaddingInline: 9,

  selectHeight: 29,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Montserrat", sans-serif',
  selectColor: "#4A4F54",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 300,

  selectBorderColor: "#ffffff",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#4A4F54",
  selectHoverBorderColor: "#FFFFFF",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 15,
  textAreaPaddingInline: 9,

  textAreaHeight: 75,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Montserrat", sans-serif',
  textAreaColor: "#4A4F54",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 300,

  textAreaBorderColor: "#FFFFFF",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#4A4F54",
  textAreaHoverBorderColor: "#FFFFFF",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#4A4F54",
  placeholderFontFamily: '"Montserrat", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 300,
  placeholderHoverColor: "#4A4F54",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 12,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 12,
  fieldLabelColor: "#FFFFFF",
  fieldLabelFontWeight: 700,
  fieldLabelColorAsterisk: "#FFFFFF",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Montserrat", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#FFFFFF",
  descriptionFontSize: 11,
  descriptionFontWeight: 500,
  descriptionFontFamily: '"Montserrat", sans-serif',
  descriptionTopSpacing: 25,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 10,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#FFFFFF",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBorderColor: "#FFFFFF",
  checkboxCheckedColor: "#009ADE",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Montserrat", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#FFFFFF",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 10,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#FFFFFF",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#009ADE",
  radioCheckedBorderColor: "#FFFFFF",

  radioAlignment: "none",

  radioLabelFontFamily: '"Montserrat", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#FFFFFF",

  // **********************************
  // submit button

  submitMarginTop: 30,
  submitFontSize: 18,
  submitFontFamily: "'Montserrat', sans-serif",
  submitWidth: 190,
  submitWidthUnits: "px",
  submitHeight: 45,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#89DC65",
  submitColor: "#4A4F54",
  submitBorderColor: "#89DC65",
  submitBackgroundHover: "#89DC65",
  submitBorderColorHover: "#89DC65",
  submitColorHover: "#4A4F54",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  